// @ts-strict-ignore
/** Functions for converting between retention bookmark data structures */

import {ResourceType} from 'common/report/constants';
import {dataGroupStore} from 'common/report/stores/data-groups';
import {propertiesUtils} from 'common/report/util/properties';
import {
  isCohortSegment,
  isEventSegment,
  isUserSegment,
  Segment,
} from 'common/query-builder/query-block/segment-menu/types';
import {getFirstSegment} from 'common/query-builder/query-block/segment-menu/types';
import {LocalizationStore} from 'common/i18n/store';

export type EventAttributionItem = {
  label: string;
  value?: string | number;
  index: string;
};

export function isSegmented(segmentGroups: Segment[]) {
  return segmentGroups?.length > 0;
}

export function getSegmentName(segmentGroups: Segment[], i18n: LocalizationStore) {
  if (isSegmented(segmentGroups) && !isSegmentedByCohort(segmentGroups)) {
    return segmentGroups.map((group) => getGroupByName(group, i18n)).join(` / `);
    // TODO: revisit for B2B properties
  } else {
    return ``;
  }
}

function isSegmentedByCohort(segmentGroups: Segment[]): boolean {
  return isSegmented(segmentGroups) && segmentGroups.some(isCohortSegment);
}

export function getGroupByName(group: Segment, i18n: LocalizationStore): string {
  if (isCohortSegment(group)) {
    return `Cohort`;
  } else if (isUserSegment(group) || isEventSegment(group)) {
    const firstSegment = getFirstSegment(group);
    const {propertyName, dataGroupId, customProperty, propertyObjectKey, listItemGroup} = firstSegment;
    return propertiesUtils.renameProperty(
      propertyName,
      isUserSegment(group) ? ResourceType.User : ResourceType.Event,
      i18n,
      {
        dataGroupId,
        customProperty,
        propertyObjectKey,
        listItemGroup,
      },
    );
  } else {
    return `Cohort`;
  }
}

export function getDataGroupName(dataGroupId, plural = false): string {
  if (!dataGroupId) {
    return plural ? `users` : `user`;
  }

  const dataGroup = dataGroupStore.value[dataGroupId];
  if (dataGroup) {
    return `${dataGroup.displayName}${plural ? `(s)` : ``}`;
  } else {
    return `profile${plural ? `(s)` : ``}`;
  }
}
